__turbopack_context__.v({
  "actionCell": "Table-module__nAzRcW__actionCell",
  "actionMenu": "Table-module__nAzRcW__actionMenu",
  "actionMenuItem": "Table-module__nAzRcW__actionMenuItem",
  "actionMenuItemDestructive": "Table-module__nAzRcW__actionMenuItemDestructive",
  "body": "Table-module__nAzRcW__body",
  "cell": "Table-module__nAzRcW__cell",
  "compact": "Table-module__nAzRcW__compact",
  "head": "Table-module__nAzRcW__head",
  "header": "Table-module__nAzRcW__header",
  "headerContent": "Table-module__nAzRcW__headerContent",
  "hoverable": "Table-module__nAzRcW__hoverable",
  "kebabBtn": "Table-module__nAzRcW__kebabBtn",
  "link": "Table-module__nAzRcW__link",
  "responsive": "Table-module__nAzRcW__responsive",
  "row": "Table-module__nAzRcW__row",
  "selected": "Table-module__nAzRcW__selected",
  "sortIcon": "Table-module__nAzRcW__sortIcon",
  "sortable": "Table-module__nAzRcW__sortable",
  "striped": "Table-module__nAzRcW__striped",
  "table": "Table-module__nAzRcW__table",
  "wrapper": "Table-module__nAzRcW__wrapper",
});
